module.exports = __webpack_public_path__ + "img/20190611_113036_008.16615fd0.jpg";